import React, { createContext, useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, message, Card } from "antd";
import MainLayout from "../../components/MainLayout";
import AddWarehouse from "./AddWarehouse";
import DataTables from "./DataTables";
import { ApiConfig } from "../../services/ApiConfigs";
import { ApiServices } from '../../services/apiServices';

export const WarehouseContext = createContext({})

const Warehouse = () => {
    const [form] = Form.useForm();
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [wareHouseData, setWarehouseData] = useState([]);
    const [selectWareHouseData, setSelectWarehouseData] = useState({});
    const [isEditMode, setIsEditMode] = useState(false);
    const [loader, setLoader] = useState(false)

    useEffect(() => {
        getWarehouse()
    }, [])

    useEffect(() => {
        if (!addModalOpen) return;
        if (Object.keys(selectWareHouseData).length > 0) {
            form.setFieldsValue({
                name: selectWareHouseData.name,
                address: selectWareHouseData.address,
                city: selectWareHouseData.city || "",
                state: selectWareHouseData.state || "",
                country: selectWareHouseData.country || "",
                pincode: selectWareHouseData.pincode || "",
                manager: selectWareHouseData.manager,
                contactPhone: selectWareHouseData.contactPhone,
                latitude: selectWareHouseData.latitude,
                longitude: selectWareHouseData.longitude,
            });
            setIsEditMode(true);
        } else {
            setIsEditMode(false);
            form.resetFields();
        }
    }, [selectWareHouseData, addModalOpen, form]);


    // Handle form submission
    const onFinish = async (values) => {
        console.log("Form Submitted:", values);
        getWarehouse()
    };

    const onClose = () => {
        setAddModalOpen(false);
        setSelectWarehouseData({});
        setIsEditMode(false);
        form.resetFields();
    };

    const deleteUser = async (id) => {
        try {
            await ApiServices('delete', ApiConfig.WAREHOUSE + '/' + id).then((res) => {
                console.log(res, "delete users response..")
                getWarehouse()
            })
        } catch (error) {
            console.log(error)
        }
    }

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            console.log("Form Data:", values);
            if (isEditMode) {
                const response = await ApiServices("put", ApiConfig.WAREHOUSE + "/" + selectWareHouseData.id, values);
                console.log(response, "add warehouse")
                if (response.status !== 200) {
                    return message.error(response.message || "Failed to register Warehouse.");
                } else {
                    message.success("Warehouse Registered Successfully!");
                    onClose();
                    getWarehouse()
                    setIsEditMode(false)
                }
            } else {
                const response = await ApiServices("post", ApiConfig.WAREHOUSE, values);
                console.log(response, "add warehouse")
                if (response.status !== 200) {
                    return message.error(response.message || "Failed to register Warehouse.");
                } else {
                    message.success("Warehouse Registered Successfully!");
                    onClose();
                    getWarehouse()
                }
            }
        } catch (error) {
            message.error("Please fill all required fields correctly.");
        }
    };

    const getWarehouse = async () => {
        try {
            setLoader(true)
            const res = await ApiServices('get', ApiConfig.WAREHOUSE);
            console.log(res, "get warehouser")
            setWarehouseData(res?.data || [])
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.log(error)
        }
    }

    const passData = {
        form,
        onFinish,
        addModalOpen,
        setAddModalOpen,
        onClose,
        handleSubmit,
        wareHouseData,
        deleteUser,
        loader,
        isEditMode,
        setIsEditMode,
        selectWareHouseData,
        setSelectWarehouseData
    }

    return (
        <WarehouseContext.Provider value={passData}>
            <MainLayout>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                    <h2 style={{ margin: 0 }}>Warehouses</h2>
                    <Button type="primary" onClick={() => {
                        setSelectWarehouseData({});
                        setIsEditMode(false);
                        form.resetFields();
                        setAddModalOpen(true);
                    }}>+ Warehouse</Button>
                </div>
                <DataTables />
                <AddWarehouse />
            </MainLayout>
        </WarehouseContext.Provider>
    );
};

export default Warehouse;
